import { Navigate, Route, Routes } from 'react-router'
import Customers from '@/app/customer/customers'
import SelectTrader from '@/app/select-trader'
import NotFound from '@/app/not-found'
import AuthLayout from '@/app/auth-layout'
import TraderLayout from '@/app/trader-layout'
import TraderLanding from '@/app/trader-landing'
import Suppliers from '@/app/supplier/suppliers'
import CustomerWizardPage from '@/app/customer/customer-wizard-page'
import KlearAccount from '@/app/klear-account/klear-account'
import MakePayment from '@/app/klear-account/make-payment'
import MakeTransfer from '@/app/klear-account/make-transfer'
import KlearFX from '@/app/klear-fx/klear-fx'
import Orders from '@/app/orders/orders'
import DocumentsPage from '@/app/document/documents-page'
import InvoiceRedirect from '@/app/document/invoice-redirect'
import KycSettings from '@/app/organization/kyc'
import ExternalBankAccountSettings from '@/app/organization/external-bank-account/list'
import TraderExternalBankAccountWizardPage from '@/app/external-bank-account/trader-external-bank-account-wizard-page'
import SupplierExternalBankAccountWizardPage from '@/app/supplier/external-bank-account/supplier-external-bank-account-wizard-page'
import SupplierWizardPage from '@/app/supplier/supplier-wizard-page'
import OrderDetail from '@/app/orders/order-detail'
import OrderCreateWizardPage from '@/app/order/order-create-wizard-page'
import PurchaseOrderCreateWizardPage from '@/app/purchase-order/purchase-order-create-wizard-page'
import OperationalWizardPage from '@/app/operational/operational-wizard-page'
import {
  ROUTE_ROOT,
  ROUTE_TRADER,
  ROUTE_CUSTOMERS,
  ROUTE_SUPPLIERS,
  ROUTE_KLEAR_FX,
  ROUTE_IDENTITY_VERIFICATION,
  ROUTE_EXTERNAL_BANK,
  ROUTE_KLEAR_ACCOUNT,
  ROUTE_MAKE_PAYMENT,
  ROUTE_TRANSFER_FUNDS,
  ROUTE_PROFILE,
  ROUTE_ORGANIZATION,
  ROUTE_TEAM,
  ROUTE_DOCUMENTS,
  ROUTE_PAYABLE,
  ROUTE_PAYABLES,
  ROUTE_RECEIVABLES,
  ROUTE_RECEIVABLE,
  ROUTE_ORDERS,
  ROUTE_PURCHASE_ORDERS,
  ROUTE_OPERATIONAL,
  ROUTE_OFFERS,
  ROUTE_BILLING
} from '@klear/constants'
import Profile from '@/app/profile'
import OrganizationDetailsSettings from '@/app/organization/details'
import TeamSettings from '@/app/organization/team'
import TeamUserAdd from '@/app/organization/team-user-add'
import TeamUserEdit from '@/app/organization/team-user-edit'
import Payables from '@/app/payables/payables'
import PayableWizardPage from '@/app/payable/payable-wizard-page'
import Receivables from '@/app/receivables/receivables'
import ReceivableWizardPage from '@/app/receivable/receivable-wizard-page'
import Billing from '@/app/billing/billing'

export default function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTE_TRADER}>
        <Route element={<AuthLayout />}>
          <Route index element={<SelectTrader />} />
          <Route path="select-trader" element={<SelectTrader />} />
          <Route path=":traderId" element={<TraderLayout />}>
            <Route index element={<TraderLanding />} />
            <Route path={ROUTE_PROFILE} element={<Profile />} />
            <Route path={ROUTE_CUSTOMERS} element={<Customers />} />
            <Route path={`${ROUTE_CUSTOMERS}/new`} element={<CustomerWizardPage mode="create" />} />
            <Route path={`${ROUTE_CUSTOMERS}/:customerId`} element={<CustomerWizardPage mode="view" />} />
            <Route path={ROUTE_SUPPLIERS} element={<Suppliers />} />
            <Route path={`${ROUTE_SUPPLIERS}/new`} element={<SupplierWizardPage mode="create" />} />
            <Route path={`${ROUTE_SUPPLIERS}/:supplierId/edit`} element={<SupplierWizardPage mode="edit" />} />
            <Route
              path={`${ROUTE_SUPPLIERS}/:supplierId/${ROUTE_EXTERNAL_BANK}/new`}
              element={<SupplierExternalBankAccountWizardPage mode="create" />}
            />
            <Route
              path={`${ROUTE_SUPPLIERS}/:supplierId/${ROUTE_EXTERNAL_BANK}/:externalBankAccountId`}
              element={<SupplierExternalBankAccountWizardPage mode="view" />}
            />
            <Route
              path={`${ROUTE_SUPPLIERS}/:supplierId/${ROUTE_EXTERNAL_BANK}/:externalBankAccountId/edit`}
              element={<SupplierExternalBankAccountWizardPage mode="edit" />}
            />
            <Route path={`${ROUTE_SUPPLIERS}/:supplierId`} element={<SupplierWizardPage mode="view" />} />
            <Route path={ROUTE_KLEAR_ACCOUNT} element={<KlearAccount />} />
            <Route path={ROUTE_MAKE_PAYMENT} element={<MakePayment />} />
            <Route path={ROUTE_TRANSFER_FUNDS} element={<MakeTransfer />} />

            <Route path={ROUTE_KLEAR_FX} element={<KlearFX />} />
            <Route path={ROUTE_PAYABLES} element={<Payables />} />
            <Route path={`${ROUTE_PAYABLE}/order/:orderId`} element={<PayableWizardPage mode="create" />} />
            <Route path={`${ROUTE_PAYABLE}/:payableId/edit`} element={<PayableWizardPage mode="edit" />} />
            <Route path={`${ROUTE_PAYABLE}/:payableId`} element={<PayableWizardPage mode="view" />} />
            <Route path={ROUTE_PAYABLE} element={<PayableWizardPage mode="create" />} />
            <Route path={ROUTE_RECEIVABLES} element={<Receivables />} />
            <Route path={`${ROUTE_RECEIVABLE}/order/:orderId`} element={<ReceivableWizardPage />} />
            <Route path={ROUTE_RECEIVABLE} element={<ReceivableWizardPage />} />
            <Route path={ROUTE_ORDERS} element={<Orders />} />
            <Route path={`${ROUTE_ORDERS}/new`} element={<OrderCreateWizardPage />} />
            <Route path={`${ROUTE_ORDERS}/:orderId`} element={<OrderDetail />} />
            <Route path={`${ROUTE_PURCHASE_ORDERS}/new`} element={<PurchaseOrderCreateWizardPage />} />
            <Route path={`${ROUTE_OPERATIONAL}/new`} element={<OperationalWizardPage mode="create" />} />
            <Route path={`${ROUTE_OPERATIONAL}/:operationalId/edit`} element={<OperationalWizardPage mode="edit" />} />
            <Route path={ROUTE_OFFERS} element={<Navigate to={`../${ROUTE_RECEIVABLES}`} replace />} />
            <Route path={ROUTE_DOCUMENTS} element={<DocumentsPage />} />
            <Route path={`${ROUTE_DOCUMENTS}/invoice/:orderId/:orderEventId`} element={<InvoiceRedirect />} />
            <Route path={ROUTE_IDENTITY_VERIFICATION} element={<KycSettings />} />
            <Route path={ROUTE_EXTERNAL_BANK} element={<ExternalBankAccountSettings />} />
            <Route
              path={`${ROUTE_EXTERNAL_BANK}/new`}
              element={<TraderExternalBankAccountWizardPage mode="create" />}
            />
            <Route
              path={`${ROUTE_EXTERNAL_BANK}/:externalBankAccountId`}
              element={<TraderExternalBankAccountWizardPage mode="view" />}
            />
            <Route
              path={`${ROUTE_EXTERNAL_BANK}/:externalBankAccountId/edit`}
              element={<TraderExternalBankAccountWizardPage mode="edit" />}
            />
            <Route path={ROUTE_ORGANIZATION} element={<OrganizationDetailsSettings />} />
            <Route path={ROUTE_TEAM} element={<TeamSettings />} />
            <Route path={`${ROUTE_TEAM}/new`} element={<TeamUserAdd />} />
            <Route path={`${ROUTE_TEAM}/:userId/edit`} element={<TeamUserEdit />} />
            <Route path={ROUTE_BILLING} element={<Billing />} />
          </Route>
        </Route>
      </Route>
      <Route path={ROUTE_ROOT} element={<Navigate to={`/${ROUTE_TRADER}`} replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
